import { ReactComponent as IconStarFillCut } from './starFillCut.svg';

export const StarFillCut = ({ ...props }): JSX.Element => (
  <IconStarFillCut {...props} />
);
